{
    "monster": {
        "key": "monster",
        "jobKey": "book/werewolf",
        "position": {
            "x": 9,
            "y": 5,
            "z": 1
        }
    },
    "54Ft8": {
        "position": {
            "x": 5,
            "y": 5,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "54Ft8"
    },
    "ashe": {
        "position": {
            "x": 5,
            "y": 6,
            "z": 1
        },
        "templateKey": "player/book/ashe",
        "key": "ashe"
    },
    "xtgor": {
        "position": {
            "x": 7,
            "y": 4,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "xtgor",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "3RCv_": {
        "position": {
            "x": 8,
            "y": 6,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "3RCv_",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "TdaTp": {
        "position": {
            "x": 8,
            "y": 5,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "TdaTp",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "page": {
        "key": "page",
        "role": "page",
        "spriteSize": "contained", "imageKey": "book/page2",
        "type": "zone",
        "properties": [
            "no healthbar"
        ],

        "position": {
            "x": 6,
            "y": 5,
            "z": 1
        },
        "pageKeys": [
            "vampire",
            "ghost",
            "ratking"
        ]
    }
}
